/**
 * Client-side mirror of llmr-shared/pkg/taxid — same 13-digit Thai
 * taxpayer-ID check-digit scheme, so the form catches a mistyped digit
 * before the request round-trips. The server validates again
 * (llmr-member-api/internal/server/tax_invoice.go) and is the actual
 * authority; this exists only for immediate feedback.
 */

/** Strips the separators a Thai taxpayer ID is normally printed with. */
export function normalizeTaxId(raw: string): string {
  return raw.replace(/[-\s]/g, '');
}

/** Checks the check digit of a normalized 13-digit Thai taxpayer ID. */
export function isValidTaxId(raw: string): boolean {
  const s = normalizeTaxId(raw);
  if (!/^\d{13}$/.test(s)) return false;

  const digits = s.split('').map(Number);
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += digits[i]! * (13 - i);
  }
  const check = (11 - (sum % 11)) % 10;
  return check === digits[12];
}
